import 'css-chunksrc/client/scenes/projectResourceEdition/form/roleSelection/styles.scss';export default {
  "roleSelection": "_roleSelection_jon68_1",
  "input": "_input_jon68_5",
  "selection": "_selection_jon68_18",
  "placeholder": "_placeholder_jon68_24",
  "list": "_list_jon68_28",
  "role": "_role_jon68_1",
  "iconBox": "_iconBox_jon68_53",
  "icon": "_icon_jon68_53",
  "opened": "_opened_jon68_63",
  "disabled": "_disabled_jon68_71"
};